import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormComponent from "../../../components/FormComponent";
import BodyWrapper from "../../../utils/BodyWrapper";
import axios from "axios";
import { API } from "../../../App";
import SponsorsContentRow from "./SponsorsContentRow";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Box } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

function AdminNewSponsor(props) {
  const sponsorId = props.match?.params.sponsorId;
  const navigate = useNavigate();
  const [input, setInput] = useState({ contents: [] });
  const subTableHeaderStyle = { fontSize: "1.9rem", color: "white" };
  const handleChange = (e) => {
    setInput({ ...input, [e.target.name]: e.target.value });
  };

  const getSponsor = async () => {
    if (!sponsorId) return;
    const sponsorResponse = await fetch(`${API}/api/admin/sp/${sponsorId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage["tk"]}`,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        }
        if (res.status === 401) {
          window.location.href = "/admin";
        }
        return null;
      })
      .catch((err) => console.log(err));
    if (sponsorResponse) {
      setInput(sponsorResponse);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    formData.append("publicationType", "img");
    let path = `/api/admin/sp/add-sponsor`;
    let method = "POST";
    if (sponsorId) {
      path = `/api/admin/sp/${sponsorId}/update`;
      method = "PUT";
    }
    try {
      axios({
        url: `${API}${path}`,
        method: method,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
          Authorization: `Bearer ${localStorage["tk"]}`,
        },
      }).then(function (response) {
        if (response.status === 200) navigate(`/admin/panel/1`);
      });
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleCheckChange = (e) => {
    const { name, checked } = e.target;
    setInput({
      ...input,
      [name]: checked,
    });
  };

  useEffect(() => {
    getSponsor();
  }, []);

  return (
    <>
      <button
        onClick={() => window.history.back()}
        className="categoryposts__backBtn"
      >
        <ArrowBackIosNewIcon />
      </button>
      <BodyWrapper>
        <Box sx={{ width: "900px" }}>
          <FormComponent
            handleSubmit={handleSubmit}
            inputs={[
              {
                name: "name",
                type: "text",
                label: "Nombre del Sponsor",
                handleChange: handleChange,
                value: input.name,
              },
              {
                name: "webSite",
                type: "text",
                label: "Sitio Web (opcional)",
                handleChange: handleChange,
                value: input.webSite,
              },
              {
                name: "order",
                type: "text",
                label: "Órden",
                handleChange: handleChange,
                value: input.order,
              },
              {
                name: "active",
                type: "checkbox",
                handleChange: handleCheckChange,
                checked: input.active,
                label: "Publicación activa?",
              },
              {
                name: "file",
                type: "file",
                label: "Cargar imagen",
                accept: "image/*",
                multiple: false,
              },
            ]}
            extraContent={
              <Box>
                <br />
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={subTableHeaderStyle}> </TableCell>
                      <TableCell style={subTableHeaderStyle}>
                        {" "}
                        Visible?
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {input?.contents.map((content) => (
                      <SponsorsContentRow c={content} />
                    ))}
                  </TableBody>
                </Table>
              </Box>
            }
          />
        </Box>
      </BodyWrapper>
    </>
  );
}

export default AdminNewSponsor;
